import { Views } from '@singularsystems/neo-react';
import TaxSummaryLookup from '../Models/Lookups/TaxSummaryLookup';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data, NeoModel } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';

@NeoModel
export default class TaxSummaryVM extends Views.ViewModelBase {
  public provisionalTaxReportsSearchCrtieria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
  
  public taxSummaryPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCrtieria, TaxSummaryLookup,
     this.provisionalTaxReportsApiClient.getTaxSummaryPagedList, {
        pageSize: 10, 
        sortAscending: true,
        fetchInitial: false,
        sortBy: "holdingReportingDate",
        initialTaskRunner: this.taskRunner,
     }
   );   

  constructor(
      taskRunner = AppService.get(Types.Neo.TaskRunner),
      private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient),
      private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
      super(taskRunner);     
  }
 public async initialise() {
 }

 public search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
   this.provisionalTaxReportsSearchCrtieria.mapFrom(searchCriteria);   
 }
}